import { setCookie, getCookie } from 'utils/cookies';

class AsideNavigation {
  constructor(element, options) {
    this._element = element;
    this._options = options;
    this._cacheSelectors();
    this._initTriggers();
    this._initCollapsible();
  }

  _cacheSelectors() {
    this._collapsibleTrigger = this._element.querySelector('.jsCollapsibleTrigger');
    this._collapsedTrigger = this._element.querySelector('.jsCollapsedTrigger');

    this._collapsibleAside = this._element.querySelector('.b2b-lite-my-account-aside');
    this._collapsibleBody = this._element.querySelector('.b2b-lite-my-account-body');
  }

  _initTriggers() {
    this._collapsibleTrigger.addEventListener('click', () => {
      this._collapsibleAside.classList.toggle('collapsed');
      this._collapsibleBody.classList.toggle('full-width');

      setCookie('MainAsideOpen', 'true');
    });

    this._collapsedTrigger.addEventListener('click', () => {
      this._collapsibleAside.classList.toggle('collapsed');
      this._collapsibleBody.classList.toggle('full-width');

      setCookie('MainAsideOpen', 'false');
    });
  }

  _initCollapsible() {
    let defaultOpen = true;

    if (getCookie('MainAsideOpen') === 'false') {
      defaultOpen = false;
    }

    if (defaultOpen) {
      this._collapsibleAside.classList.remove('collapsed');
      this._collapsibleBody.classList.remove('full-width');
      setCookie('MainAsideOpen', 'true');
    } else {
      this._collapsibleAside.classList.add('collapsed');
      this._collapsibleBody.classList.add('full-width');
      setCookie('MainAsideOpen', 'false');
    }
  }
}

export default AsideNavigation;
